const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the content picker component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('assignmentEscalators', ['Users', '$translate', function(Users, $translate) {
  return {
    restrict: 'E',
    scope: {
      values: '='
    },
    template: require('../../../templates/directives/assignments/assignment-escalators.html'),
    controller: ['$scope', function ($scope) {
      var self = this;

      self.helpers = {
        getLocation: function(user) {
          if (user && user.linked_locations && user.linked_locations[0] && user.linked_locations[0].name) {
            return user.linked_locations[0].name;
          }
          return '-----';
        },
        getDepartment: function(user) {
          if (user && user.linked_departments && user.linked_departments[0] && user.linked_departments[0].name) {
            return user.linked_departments[0].name;
          }
          return '-----';
        },
        getTeams: function(user) {
          if (user && user.linked_teams) {
            var steams = '';
            user.linked_teams.forEach(function (team) {
              steams += team.name + ',';
            });
            return steams.slice(-1);
          }
          return '-----';
        },
        getOrgLevel: function(user) {
          if (user && user.linked_org_level) {
            return user.linked_org_level.name;
          }
          return '-----';
        },
        getGrade: function(user) {
          if (user && user.linked_grade) {
            return user.linked_grade.name;
          }
          return '-----';
        }
      };

      self.queried = {
        show: false,
        allowNext: true,
        noMatch: false,
        users: [],
        query: {},
        getStandardQuery: function() {
          var q = {
            subresource: '',
            page: 1,
            per_page: 10,
            fields: '_id,first_name,last_name,email,full_name,role,image,linked_locations,linked_departments,linked_teams,linked_org_level,linked_grade,job_title,last_login,createdAt,hired,manager_email',
            'linked_locations-populate': 'name',
            'linked_departments-populate': 'name',
            'linked_teams-populate': 'name',
            'linked_org_level-populate': 'name',
            'linked_grade-populate': 'name'
          };
          return q;
        },
        onQuery: function(opts) {
          self.queried.query = self.queried.getStandardQuery();
          if (!opts || typeof opts === 'object' && !Object.keys(opts).length) {
            self.queried.noMatch = false;
            self.queried.load();
            return;
          }
          self.queried.noMatch = true;

          self.queried.query.page = 1;
          for (var key in opts) {
            self.queried.query[key] = opts[key];
          }

          self.queried.load();
        },
        load: function(denied) {
          self.queried.loading = true;
          self.queried.allowNext = true;
          Users.find(self.queried.query, function (users) {
            self.queried.loading = false;
            if (users.length < self.queried.query.per_page) {
              self.queried.allowNext = false;
              if (!users.length && self.queried.query.page > 1) {
                self.queried.query.page--;
                self.queried.load(true);
                return;
              }
            }
            self.queried.users = users;
            if (denied) {
              self.queried.allowNext = false;
            }
          }, function (error) {
            console.log('Error getting users:', error);
          });
        },
        nextPage: function() {
          if (!self.queried.allowNext) {
            return;
          }
          self.queried.query.page++;
          self.queried.load();
        },
        previousPage: function() {
          if (self.queried.query.page < 2) {
            return;
          }
          self.queried.query.page--;
          self.queried.load();
        }
      };

      self.selected = {
        hasSelectionChange: false,
        users: [],
        isSelected: function(user) {
          if (!user || !user._id || !$scope.values || !$scope.values.escalation_contacts || !$scope.values.escalation_contacts.length) {
            return false;
          }
          return $scope.values.escalation_contacts.indexOf(user._id) !== -1;
        },
        select: function(user) {
          if (!user || !user._id || self.selected.isSelected(user)) {
            return;
          }
          if (!$scope.values.escalation_contacts) {
            $scope.values.escalation_contacts = [];
          }
          $scope.values.escalation_contacts.push(user._id);
          self.selected.hasSelectionChange = true;
          self.selected.load();
        },
        remove: function(user) {
          if (!user || !user._id || !$scope.values || !$scope.values.escalation_contacts || !$scope.values.escalation_contacts.length || !self.selected.isSelected(user)) {
            return;
          }
          for (var i = 0; i < $scope.values.escalation_contacts.length; i++) {
            if ($scope.values.escalation_contacts[i] === user._id) {
              self.selected.hasSelectionChange = true;
              $scope.values.escalation_contacts.splice(i, 1);
              self.selected.load();
              return;
            }
          }
        },
        load: function() {
          self.selected.loading = true;
          if (!$scope.values || !$scope.values.escalation_contacts || !$scope.values.escalation_contacts.length) {
            self.selected.users = [];
            self.selected.loading = false;
            return;
          }
          Users.find({
            subresource: '',
            page: 1,
            per_page: 20,
            fields: '_id,first_name,last_name,email,full_name,role,image,linked_locations,linked_departments,linked_teams,linked_org_level,linked_grade,job_title,last_login,createdAt,hired,manager_email',
            'linked_locations-populate': 'name',
            'linked_departments-populate': 'name',
            'linked_teams-populate': 'name',
            'linked_org_level-populate': 'name',
            'linked_grade-populate': 'name',
            _id: '$in,' + $scope.values.escalation_contacts.length + ',' + $scope.values.escalation_contacts.join(',')
          }, function (users) {
            self.selected.users = users;
            self.selected.loading = false;
          }, function (error) {
            console.log('Error getting users:', error);
            self.selected.loading = false;
          });
        }
      };

      self.initialize = function() {
        if (!$scope.values) {
          return;
        }
        if (!$scope.values.escalation_contacts) {
          $scope.values.escalation_contacts = [];
        }
        self.queried.show = $scope.values.escalation_contacts.length ? true : false;
        self.selected.load();

        // Refresh list when the parent object has finally loaded in.
        $scope.$watch('values', function(newVal, oldVal) {
          if (!newVal || newVal === oldVal) {
            return;
          }
          // Only allow the load from the watch when it's changed externally, not by user actions here.
          if (self.selected && self.selected.users.length == 0 && newVal.escalation_contacts.length > 0 && !self.selected.hasSelectionChange) {
            self.selected.load();
          }
          self.selected.hasSelectionChange = false;
        }, true);
      };

      $translate(['assignmentEscalation.placeholder']).then(function (translations) {
        self.searchPlaceholder = translations['assignmentEscalation.placeholder'];
      });

      self.initialize();
    }],
    controllerAs: 'escalation'
  };
}]);